import { useAuthStore } from '@/lib/stores/authStore';
import type { StreamingCDSSData } from '@/lib/types/consultation';

const API_BASE_URL = import.meta.env.VITE_AUTH_API_URL;

function getAuthHeaders(): Record<string, string> {
  const token = useAuthStore.getState().token;
  return {
    'Content-Type': 'application/json',
    ...(token ? { Authorization: `Bearer ${token}` } : {}),
  };
}

export const consultationRecordsApi = {
  /**
   * Save or update a consultation record
   */
  saveRecord: async (
    encounterId: string,
    practitionerId: string,
    patientId: string,
    patientName: string,
    practitionerName: string,
    encounterDate: string,
    cdssData: StreamingCDSSData
  ): Promise<{
    success: boolean;
    record: { id: string; encounterId: string; updatedAt: string };
  }> => {
    const response = await fetch(`${API_BASE_URL}/api/consultation-records`, {
      method: 'POST',
      headers: getAuthHeaders(),
      body: JSON.stringify({
        encounterId,
        practitionerId,
        patientId,
        patientName,
        practitionerName,
        encounterDate,
        cdssData,
      }),
    });

    if (!response.ok) {
      const errorData = await response.json().catch(() => ({}));
      throw new Error(errorData.error || `Failed to save consultation record: ${response.status}`);
    }
    return response.json();
  },
};
